import { Value } from '@philips-internal/oswald-ui-core';

export class WoundsDressingsTabListContext {
  static state: Record<string, Value>;
  static currentTab = '';

  static set(data: Record<string, Value>): void {
    this.state = data;
  }

  static clean(): void {
    this.currentTab = '';
    this.state = {};
  }

  static get(): Record<string, Value> {
    return this.state;
  }
}
